import Const from 'const';

const subjectsMap = {
    [Const.LEAGUE_CFB]:
        '' +
        'In order to simplify lineups optimization the ‘Relax build rules’ checkbox impacts the next settings:\n' +
        'Set Min/Max Salaries to their defaults for the Salary Cap;\n' +
        'Ignore all Stacking rules;\n' +
        'Set number of Unique Players to 1;\n' +
        "Set all Players' Min/Max Exposures to defaults (0% and 100%);\n",
    [Const.LEAGUE_MLB]:
        '' +
        'In order to simplify lineups optimization the ‘Relax build rules’ checkbox impacts the next settings:\n' +
        'Set Min/Max Salaries to their defaults for the Salary Cap;\n' +
        'Set Min/Max ProjOwn to defaults for the Projected Ownership Cap;\n' +
        'Ignore all Stacking rules;\n' +
        'Set number of Unique Players to 1;\n' +
        "Set all Players' Min/Max Exposures to defaults (0% and 100%);\n" +
        'Ignore the ‘Force at least x players…’;\n' +
        "Enable 'Allow hitters vs opposing pitchers…'.",
    [Const.LEAGUE_NBA]:
        '' +
        'In order to simplify lineups optimization the ‘Relax build rules’ checkbox impacts the next settings:\n' +
        'Set Min/Max Salaries to their defaults for the Salary Cap;\n' +
        'Set Min/Max ProjOwn to defaults for the Projected Ownership Cap;\n' +
        'Ignore all Stacking rules;\n' +
        'Set number of Unique Players to 1;\n' +
        "Set all Players' Min/Max Exposures to defaults (0% and 100%);\n" +
        'Ignore the ‘Force at least x players…’.',
    [Const.LEAGUE_NFL]:
        '' +
        'In order to simplify lineups optimization the ‘Relax build rules’ checkbox impacts the next settings:\n' +
        'Set Min/Max Salaries to their defaults for the Salary Cap;\n' +
        'Set Min/Max ProjOwn to defaults for the Projected Ownership Cap;\n' +
        'Ignore all Stacking rules;\n' +
        'Set number of Unique Players to 1;\n' +
        "Set all Players' Min/Max Exposures to defaults (0% and 100%);\n" +
        'Ignore the ‘Force at least x players…’;\n' +
        'Set Players vs Defense to "max 6 Players";\n' +
        "Ignore the 'Disallow more than one pass catcher (TE, WR) ...'",
};

export function getSubjectBySport(sport: string): string {
    return sport in subjectsMap ? subjectsMap[sport] : '';
}
